export const validateVideoLink = (videoLink) => {
  const youtubeEmbedRegex =
    /^youtube\.com\/embed\/[A-Za-z0-9_-]{11}$/;
  if (youtubeEmbedRegex.test(videoLink)) {
    return null;
  }
  return 'Video Link should be of format: "youtube.com/embed/<11-digit-id>"';
};

export const validateThumbnailLink = (thumbnailLink) => {
  var onlineImageLinkRegex = /(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/;
  if (onlineImageLinkRegex.test(thumbnailLink)) {
    return null;
  }
  return "Please enter a valid Thumbnail URL ending with .jpg/.gif/.png";
};
